import React from 'react';
import { Calendar, CalendarCheck, Zap, ExternalLink } from 'lucide-react';
import { Camp, CampDate } from '../../../utils/types';
import { CampFormatUtils } from '../../../utils/campFormatUtils';
import './CampDatesSection.css';

interface CampDatesSectionProps {
  camp: Camp;
  scheduledDateIds?: string[];
  isInstantBooking: boolean;
  onBookDate: (campDate: CampDate) => void;
  onScheduleToggle?: (campDateId: string) => void;
  className?: string;
}

const CampDatesSection: React.FC<CampDatesSectionProps> = ({
  camp,
  scheduledDateIds = [],
  isInstantBooking,
  onBookDate,
  onScheduleToggle,
  className = ''
}) => {
  const isDateScheduled = (dateId: string): boolean => {
    return scheduledDateIds.includes(String(dateId));
  };

  const sortedDates = [...camp.camp_dates].sort(
    (a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
  );

  return (
    <div className={`camp-dates-section ${className}`}>
      <h3 className="camp-dates-title">
        <Calendar className="icon icon--sm" />
        Available Dates
      </h3>
      <div className="camp-dates-list">
        {sortedDates.map((campDate) => {
          // Note: current_capacity is the number of bookings already made
          const availableSpots = campDate.max_capacity - campDate.current_capacity;
          const isFull = availableSpots <= 0;

          return (
            <div key={campDate.id} className="camp-date-row">
              <div className="camp-date-info">
                <span className="camp-date-range">
                  {CampFormatUtils.formatDateRange(campDate.start_date, campDate.end_date, true)}
                </span>
              </div>
              <div className="camp-date-actions">
                {isInstantBooking ? (
                  <button
                    className="btn btn--instant-booking btn--sm"
                    onClick={() => onBookDate(campDate)}
                    disabled={isFull}
                  >
                    {isFull ? (
                      'Camp Full'
                    ) : (
                      <><Zap className="icon icon--xs" /> Book Now</>
                    )}
                  </button>
                ) : (
                  <button
                    className="btn btn--primary btn--sm"
                    onClick={() => onBookDate(campDate)}
                    disabled={!camp.website}
                  >
                    Book Now
                    <ExternalLink className="icon icon--xs" />
                  </button>
                )}
                {onScheduleToggle && (
                  <button
                    className="btn btn--secondary btn--sm"
                    onClick={() => onScheduleToggle(String(campDate.id))}
                  >
                    {isDateScheduled(String(campDate.id)) ? 'Remove from Plan' : 'Add to Plan'}
                    <CalendarCheck className="icon icon--xs" />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CampDatesSection;
